module.exports = __webpack_public_path__ + "img/703.cacd10ce.jpg";